
import api from "~api";
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'

import {mapMutations} from 'vuex'
export default {
name: 'login',
components:{Group,Cell,XInput,XButton,Loading,Toast,Selector,ButtonTab,ButtonTabItem },
data () {
return {
isStudent:true, //默认学生登录
tabIndex:0,// 默认选中学生登录
user: '',
idcard:'',
isbind:false,
showloading:false,
bodyHeight:'',
from:'',
showtoast:false,
toasttext:'',
openid:'',
type: '1',
userCode:'', //工号
password:'', //密码
options: [{
key: 1,
value: '考生号（新生）'
}, {
key: 2,
value: '学号（老生）'
}],
}
},
beforeRouteEnter (to, from, next) {
next(vm => {

console.log(to);
console.log(from);
vm.from = from.fullPath;
})
},
mounted() {
this.bodyHeight=document.body.clientHeight;
},
methods: {
checkuser() {
var userreg = /^[0-9a-zA-Z]*$/g;
var _this = this;
if(_this.user == ''||_this.user ==null){
_this.toasttext = "请输入学号或考生号";
_this.showtoast=true;
return false;
}else if (!userreg.test(_this.user)){
_this.toasttext = "请输入正确的学号或考生号";
_this.showtoast=true;
return false;
}
return true;
},
checkUserCode() {
var userreg = /^[0-9a-zA-Z]*$/g;
var _this = this;
if(_this.userCode == ''||_this.userCode ==null){
_this.toasttext = "请输入工号";
_this.showtoast=true;
return false;
}else if (!userreg.test(_this.userCode)){
_this.toasttext = "请输入正确的工号";
_this.showtoast=true;
return false;
}
return true;
},
checkidcard() {
var idcardreg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
var _this = this;
if(_this.idcard == ''||_this.idcard ==null){
_this.toasttext = "请输入身份证号";
_this.showtoast=true;
return false;
}else if (!idcardreg.test(_this.idcard)){
_this.toasttext = "请输入正确的身份证号";
_this.showtoast=true;
return false;
}
return true;
},
checkPassword() {
var _this = this;
if(_this.password == ''||_this.password ==null){
_this.toasttext = "请输入密码";
_this.showtoast=true;
return false;
}
return true;
},
changeType(){
var _this = this;
if(_this.type == ''||_this.type ==null){
_this.toasttext = "请选择输入类型";
_this.showtoast=true;
return false;
}
return true;
},

login () {
var _this = this;
_this.openid = _this.$store.state.open_id?_this.$store.state.open_id:window.localStorage.getItem('openId');
if (_this.checkidcard() && _this.checkuser() ) {
if (_this.openid != '') {
var param  = {
"idCard": _this.idcard,
"openId": _this.openid
};
if(this.type==1){
param["examNumber"] = _this.user;
}else{
param["stuNumber"] = _this.user;
}
api.post('/api/binding/bindOpenId', param).then(function (response) {
var data = response.data;
if (data.results == 1) {
_this.getInfo();
} else {
_this.$msgbox('温馨提示：', "您绑定的信息有误");
}
});
} else {
window.localStorage.removeItem('access_token');
_this.$router.push('/');
}
}else{

}
},

teacherLogin () {
var _this = this;
_this.openid = _this.$store.state.open_id?_this.$store.state.open_id:window.localStorage.getItem('openId');
if (_this.checkPassword() && _this.checkUserCode() ) {
if (_this.openid != '') {
var param  = {
"userCode": _this.userCode,
"openId": _this.openid,
"password":_this.password
};

api.post('/api/sys/login', param).then(function (response) {
var data = response.data;

if (data.code == "0") {
window.localStorage.setItem("userCode",_this.userCode);
window.localStorage.setItem("userName",data.user.userName);
window.localStorage.setItem("token",data.token); 

if(!_this.$route.params.app){
_this.$router.push({name: _this.$route.params.app, params:{userCode:_this.userCode}});
}else{
_this.$router.push({name: 'home'});
}
} else {
_this.$msgbox('温馨提示：', "您绑定的信息有误");
}
});
} else {
window.localStorage.removeItem('access_token');
_this.$router.push('/');
}
}
},
getInfo(){
var _this = this;
if( _this.user != '' && _this.idcard != ''){
_this.$vux.loading.show({
text: 'Loading'
})

var param = {
"idCard": _this.idcard
};
if(_this.type == 1){
param["examNumber"] = _this.user;
}else{
param["stuNumber"] = _this.user;
}
api.post('/api/binding/findstu', param).then(function (response) {
if (response.status == 200){
var data = response.data;
var info = data.results;
if(info == null ){
_this.$msgbox('温馨提示：',"您绑定的信息有误");
_this.$vux.loading.hide()
}else{
window.localStorage.setItem("stuCode",info.stuCode);
window.localStorage.setItem("token",data.token);
window.localStorage.setItem("stuIsReport",data.stuIsReport);
window.localStorage.setItem("enrollType",data.enrollType);

_this.changeName(info.name);
_this.changeStuNumber(info.stuNumber);
_this.changePhone(info.telephone);
_this.changeMajor(info.majorName);
_this.changeIdcard(info.idCard);
_this.changeBind(true);
_this.$vux.loading.hide();
_this.$router.push({name: 'home'});







}
}else {
_this.$msgbox('温馨提示：',"请检查您绑定的信息");
_this.$vux.loading.hide()
}
})
}else{
_this.$msgbox('温馨提示：',"绑定的信息不能为空");
}
},
changeTabIndex(){
if(this.tabIndex == 0){
this.isStudent = true;
}else if(this.tabIndex == 1){
this.isStudent = false;
}
},
...mapMutations(['changeName','changeStuNumber','changePhone','changeMajor','changeBind','changeIdcard']),
}
}



// WEBPACK FOOTER //
// ./src/components/Login.vue